export let dto_StartupPageLoadInfo = {
  SingleAdvertURL: String,
  isMobileGpsEnabled: Boolean,
  dtoZoneList: Array,
  isMobileAddressMap: Boolean,
  PhoneNoDetails: String,
  Currency: String,
  isLoadQrCode: Boolean,
  ContactUs: String,
  AdvertisementUrl: String,
  PayModeTypes: String,
  DefaultLocation: String,
  AppBlock: String,
  isPromoEnabled: Boolean,
  isDineTypeButtonCall: Boolean,
  isRiderOrderCancel: Boolean,
  isRiderDeliveryPath: Boolean,
  isRiderReportsDisplay: Boolean,
  BankTransferAccountDetails: String,
  HomePageBackgroundImageUrl: String,
  isManualAddressVisible: Boolean,
  AllowScheduledOrders: Boolean,
  ScheduledOrderTimeGap: Number,
  DefaultDineType: Number,
  isDisplayAllMerchantTypes: Boolean,
  MerchantProductPricePer: Number,
  IOSAllowLocationPermission: Boolean,
  isTrackAnalytics: Boolean,
  isDisplayEstDeliveryCharges: Boolean,
  DisplayDineType: Number,
  isDisplayInvDownloadButton: Boolean,
  isDisplayRecommendation: Boolean,
  IsEnableGoogleMapsSearch: Boolean,
  GoogleMapsAPIKey: String,
  AppTimeout: Number,
  DisplayCustomerNotification: Boolean,
  CheckCustomerSignout: Boolean,
  SharingUrl: String,
  isDisplayLoyaltyPoints: Number,
  isDisplaySignOut: Boolean,
  DefaultLat: Number,
  DefaultLong: Number,
  CountryPhoneCode: Number,
  CountryPhoneLength: Number,
  CountryFlag: String,
  IsMLProduct: Boolean,
};
